import { Table, type TableProps } from "antd";

interface DFPTableProps extends TableProps {}

export const DFPTable = ({ ...props }: DFPTableProps) => {
	return <Table {...props} />;
};
